<template>
  <Transition
    enter-active-class="transition-opacity duration-150 ease-out"
    leave-active-class="transition-opacity duration-200 ease-in"
    enter-from-class="opacity-0"
    leave-to-class="opacity-0"
  >
    <div
      v-if="visible"
      class="fixed inset-0 z-[200] flex items-center justify-center bg-black/40 backdrop-blur-[2px]"
      role="status"
      aria-live="polite"
      aria-busy="true"
      :aria-label="message"
      data-testid="global-loading-overlay"
    >
      <div
        class="flex min-w-[220px] max-w-[min(90vw,24rem)] flex-col items-center gap-3 rounded-lg border border-border bg-background px-6 py-5 shadow-notion-lg"
      >
        <Loader2 class="h-8 w-8 animate-spin text-primary" />
        <p class="text-center text-sm text-muted-foreground">{{ message }}</p>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { Loader2 } from 'lucide-vue-next';
import { useGlobalLoading } from '@/shared/composables/useGlobalLoading';

const { visible, message } = useGlobalLoading();
</script>
